var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group bmd-form-group"},[_c('label',[_vm._v(_vm._s(_vm.observation.user.name)+"("+_vm._s(_vm.observation.user.username)+") "+_vm._s(_vm._f("moment")(_vm.observation.created_at,'DD/MM/YYYY HH:mm:ss'))+" - "+_vm._s(_vm.observation.text))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }